import React, { useState, useContext, useEffect } from 'react';
import { Users, ShoppingBag, TrendingUp, MessageSquare, Plus, Camera, ChevronRight, Bell, ArrowLeft, Share2, Star, BarChart3, Activity, Search, Eye } from 'lucide-react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import AppContext from '../../context/AppContext';
import { useNavigation } from '../../context/NavigationContext';
import { TelegramWebApp } from '../../telegram-webapp';
import { database, ref, onValue, off } from '../../FirebaseConfig';


const GroupDetails = ({ 
  group = {
    nom: "Constantine",
    idGroup: "-1002381892923",
    type: "groupe",
    membres: 1234,
    produits: 12,
    ventes: 45,
    produitsListe: [
      { id: 1, nom: "T-shirt Premium", prix: 29.99, stock: 50, image: "/api/placeholder/200/200" },
      { id: 2, nom: "Casquette", prix: 19.99, stock: 30, image: "/api/placeholder/200/200" }
    ]
  }
}) => {
  const [showNewProduct, setShowNewProduct] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [groupProducts, setGroupProducts] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);
  
  const navigate = useNavigate();
  const { isSplashVisible, isLoading, id, userInfos, bottom, userProducts, setUserProducts, abonnementProduit, ontg } = useContext(AppContext);
  const location = useLocation();
  const { idGroup, type, nom } = useParams();
  const { navigateTo, goBack } = useNavigation();
  
  // Le NavigationContext s'occupe de la gestion du bouton retour de Telegram

  // État local pour stocker les abonnements de ce groupe
  const [groupAbonnements, setGroupAbonnements] = useState([]);
  const [isLoadingAbonnements, setIsLoadingAbonnements] = useState(true);
  
  // Effet pour charger les abonnements directement depuis Firebase
  useEffect(() => {
    if (!id || !idGroup) return;
    
    console.log("Chargement des abonnements depuis Firebase pour le vendeur", id);
    setIsLoadingAbonnements(true);
    
    // Référence aux abonnements du vendeur
    const abonnementsRef = ref(database, `abonnementpourvendeur/${id}`);
    
    // Écouteur pour obtenir les abonnements en temps réel
    const unsubscribe = onValue(abonnementsRef, (snapshot) => {
      if (snapshot.exists()) {
        const abonnementsData = snapshot.val();
        console.log("Abonnements trouvés pour le vendeur:", abonnementsData);
        
        // Filtrer les abonnements pour ce groupe spécifique
        const filteredAbonnements = [];
        Object.keys(abonnementsData).forEach(aboId => {
          const abonnement = abonnementsData[aboId];
          // Certains utilisent groupId, d'autres groupeId
          if (abonnement && (abonnement.groupId === idGroup || abonnement.groupeId === idGroup)) {
            filteredAbonnements.push({
              id: aboId,
              ...abonnement
            });
          }
        });
        
        console.log(`Abonnements filtrés pour le groupe ${idGroup}:`, filteredAbonnements);
        setGroupAbonnements(filteredAbonnements);
      } else {
        console.log("Aucun abonnement trouvé pour ce vendeur");
        setGroupAbonnements([]);
      }
      setIsLoadingAbonnements(false);
    }, (error) => {
      console.error("Erreur lors du chargement des abonnements:", error);
      setIsLoadingAbonnements(false);
      setGroupAbonnements([]);
    });
    
    // Nettoyage de l'écouteur
    return () => {
      off(abonnementsRef);
    };
  }, [id, idGroup]);
  
  // Calculer le nombre d'abonnements pour ce groupe
  const nbAbonnements = groupAbonnements.length;

  // Fonction simplifiée pour obtenir le nombre de produits - utilise directement le tableau groupProducts
  const nproduit = () => {
    return groupProducts.length;
  };
    
  // Fonction simplifiée pour filtrer les produits par terme de recherche
  const getFilteredProducts = () => {
    if (!groupProducts || !Array.isArray(groupProducts)) return [];
    
    // Si un terme de recherche est présent, filtrer les produits
    if (searchTerm) {
      return groupProducts.filter(product => 
        product.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // Sinon, retourner tous les produits du groupe
    return groupProducts;
  };

  const handleImageChange = () => {
    setImagePreview("/api/placeholder/400/320");
  };

  const statCards = [
   // { title: "Membres", value: group.membres.toLocaleString(), icon: Users, color: "bg-blue-500" },
    { title: "Produits", value: groupProducts.length, icon: ShoppingBag, color: "bg-green-500" },
    { title: "Ventes", value: isLoadingAbonnements ? "..." : nbAbonnements, icon: TrendingUp, color: "bg-purple-500" }
  ];


  // Effet pour charger les produits directement depuis Firebase
  useEffect(() => {
    if (!id || !idGroup) return;
    
    console.log("Chargement des produits depuis Firebase pour l'utilisateur", id);
    setIsLoadingProducts(true);
    
    // Référence à tous les produits de l'utilisateur
    const productsRef = ref(database, `products/${id}`);
    
    // Écouteur pour obtenir les produits en temps réel
    const unsubscribe = onValue(productsRef, (snapshot) => {
      if (snapshot.exists()) {
        const productsData = snapshot.val();
        console.log("Produits trouvés dans Firebase:", productsData);
        
        // Filtrer les produits pour ce groupe spécifique et les convertir en tableau
        const filteredProducts = [];
        Object.keys(productsData).forEach(productId => {
          const product = productsData[productId];
          if (product && product.idGroup === idGroup) {
            filteredProducts.push(product);
          }
        });
        
        console.log(`Produits filtrés pour le groupe ${idGroup}:`, filteredProducts);
        
        // Trier par date (plus récents d'abord)
        filteredProducts.sort((a, b) => {
          const dateA = a.updated_at || a.created_at || 0;
          const dateB = b.updated_at || b.created_at || 0;
          return new Date(dateB) - new Date(dateA);
        });
        
        setGroupProducts(filteredProducts);
      } else {
        console.log("Aucun produit trouvé dans Firebase pour cet utilisateur");
        setGroupProducts([]);
      }
      setIsLoadingProducts(false);
    }, (error) => {
      console.error("Erreur lors du chargement des produits:", error);
      setIsLoadingProducts(false);
      setGroupProducts([]);
    });
    
    // Nettoyage de l'écouteur
    return () => {
      off(productsRef);
    };
  }, [id, idGroup]);

  return (
    <div className="min-h-screen bg-white pb-24">
      {/* Header simplifié mais élégant */}
      <div className="bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-4 pt-4">
          <div className="flex items-center justify-between">
            {/* Bouton retour utilisant le NavigationContext */}
            <button 
              onClick={goBack}
              className="p-2 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
            
            {/* Bouton Ajouter Produit simplifié */}
            <button
              onClick={() => navigate(`/ajouterProduit/${idGroup}`)}
              className="flex items-center space-x-1 bg-white text-blue-600 px-3 py-2 rounded-full font-medium shadow-sm hover:bg-blue-50 transition-all"
            >
              <Plus className="w-4 h-4" />
              <span>Ajouter Produit</span>
            </button>
          </div>
          
          <div className="flex items-center space-x-4 mt-4 pb-6">
            <div className="p-3 rounded-full bg-white bg-opacity-20">
              <MessageSquare className="w-7 h-7" />
            </div>
            <div>
              <h1 className="text-xl font-bold">{nom}</h1>
              <p className="text-sm text-blue-100">
                {type === 'canal' ? 'Canal' : 'Groupe'} • ID: {idGroup}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu principal simplifié */}
      <div className="max-w-4xl mx-auto px-4 py-4">
        {/* Stats Cards simplifiées */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          {statCards.map((stat, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl shadow-sm p-4 border border-gray-100"
            >
              <div className="flex items-center space-x-3">
                <div className={`p-2 rounded-lg ${stat.color} bg-opacity-10`}>
                  <stat.icon className={`w-5 h-5 ${stat.color.replace('bg-', 'text-')}`} />
                </div>
                <div>
                  <p className="text-lg font-bold">{stat.value}</p>
                  <p className="text-xs text-gray-500">{stat.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Section des produits simplifiée mais élégante */}
{!showNewProduct && !selectedProduct && (
  <div className="space-y-4">
    {/* Activité simplifiée */}
    <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
      <div className="flex items-center space-x-3">
        <Bell className="w-5 h-5 text-blue-600" />
        <p className="text-sm text-blue-700">
          Dernière activité il y a 5 min
        </p>
      </div>
    </div>

    {/* Liste des produits simplifiée */}
    <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
      <div className="p-4 border-b flex items-center justify-between">
        <h2 className="text-lg font-semibold">Vos produits</h2>
        <div className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-700">
          {nproduit()} Produits
        </div>
      </div>
      
      <div className="divide-y">
        {isLoadingProducts ? (
          <div className="p-8 text-center text-gray-500">
            <div className="animate-pulse flex justify-center">
              <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
            </div>
            <p className="mt-3">Chargement des produits...</p>
          </div>
        ) : getFilteredProducts().length > 0 ? (
          getFilteredProducts()
            .slice(0, searchTerm ? 10 : 3)
            .map((produit) => (
              <div 
                key={produit.id}
                onClick={() => setSelectedProduct(produit)}
                className="flex items-center space-x-4 p-4 hover:bg-gray-50 cursor-pointer"
              >
                {produit?.imageUrl ? (
                  <img 
                    src={produit.imageUrl} 
                    alt={produit.title}
                    className="w-16 h-16 object-cover rounded-lg border border-gray-100"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/200";
                    }}
                  />
                ) : (
                  <div className="w-16 h-16 bg-gray-100 flex items-center justify-center rounded-lg border border-gray-100">
                    <ShoppingBag className="w-8 h-8 text-gray-300" />
                  </div>
                )}
                <div className="flex-1">
                  <h3 className="font-medium">{produit.title}</h3>
                  <p className="text-blue-600 font-semibold">{produit.price} F CFA</p>
                  {produit.description && (
                    <p className="text-xs text-gray-500 line-clamp-1 mt-1">
                      {produit.description}
                    </p>
                  )}
                </div>
                <div className="flex flex-col items-end">
                  <div className="flex items-center text-xs text-gray-500 mb-1">
                    <Bell className="w-3 h-3 mr-1" />
                    {produit.sales || 0} ventes
                  </div>
                  <ChevronRight className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            ))
        ) : (
          <div className="p-8 text-center text-gray-500">
            <ShoppingBag className="w-10 h-10 mx-auto mb-3 text-gray-400" />
            <p>Aucun produit disponible</p>
            <p className="text-xs text-gray-400 mt-2">
              Ajoutez des produits pour commencer à vendre
            </p>
          </div>
        )}
      </div>
    </div>
    
    {/* Barre de recherche des produits du groupe */}
    {groupProducts.length > 3 && (
      <div className="mt-4 mb-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Rechercher un produit..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-gray-50 border border-gray-100 rounded-xl py-3 pl-10 pr-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
        </div>
      </div>
    )}
    
    {/* Bouton pour voir tous les produits */}
    {groupProducts.length > 0 && (
      <button
        className="w-full bg-blue-50 text-blue-600 p-3 rounded-xl font-medium flex items-center justify-center space-x-2 border border-blue-100 mt-3"
        onClick={() => navigate(`/ProductsList`)}
      >
        <span>Voir tous les produits</span>
        <ChevronRight className="w-5 h-5" />
      </button>
    )}
  </div>
)}

        {/* Suppression du bouton flottant en bas puisqu'il est maintenant en haut */}

        {/* Vue détaillée du produit simplifiée */}
        {selectedProduct && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="relative">
              <img 
                src={selectedProduct.imageUrl || "https://via.placeholder.com/400"}
                alt={selectedProduct.title}
                className="w-full h-48 object-cover"
              />
              <button 
                onClick={() => setSelectedProduct(null)}
                className="absolute top-4 left-4 p-2 bg-white rounded-full shadow"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-4">
              <h3 className="text-xl font-bold mb-1">{selectedProduct.title}</h3>
              <p className="text-2xl text-blue-600 font-bold mb-4">{selectedProduct.price} F CFA</p>
              
              <div className="space-y-3">
                <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
                  <div className="flex items-center space-x-3">
                    <ShoppingBag className="w-5 h-5 text-blue-600" />
                    <p className="text-blue-700">
                      <span className="font-semibold">{selectedProduct.stock || "∞"}</span> en stock
                    </p>
                  </div>
                </div>
                
                <button className="w-full bg-blue-600 text-white p-3 rounded-lg font-medium">
                  Modifier le produit
                </button>
              </div>
            </div>
          </div>
        )}

        {/* New Product Form */}
        {showNewProduct && (
          <div className="bg-white rounded-xl shadow-sm">
            <div className="p-4 border-b flex items-center justify-between">
              <h2 className="text-lg font-bold">Nouveau produit</h2>
              <button 
                onClick={() => setShowNewProduct(false)}
                className="p-2"
              >
                <ChevronRight className="w-5 h-5 rotate-180" />
              </button>
            </div>
            
            <div className="p-4 space-y-4">
              <div 
                onClick={handleImageChange}
                className="aspect-square rounded-xl border-2 border-dashed border-gray-300 flex flex-col items-center justify-center cursor-pointer hover:border-purple-500"
              >
                {imagePreview ? (
                  <img 
                    src={imagePreview} 
                    alt="Preview" 
                    className="w-full h-full object-cover rounded-xl"
                  />
                ) : (
                  <>
                    <Camera className="w-12 h-12 text-gray-400 mb-2" />
                    <p className="text-sm text-gray-500">Ajouter une photo</p>
                  </>
                )}
              </div>

              <div className="space-y-4">
                <input 
                  type="text"
                  placeholder="Nom du produit"
                  className="w-full p-4 border border-gray-300 rounded-xl"
                />
                <input 
                  type="number"
                  placeholder="Prix en €"
                  className="w-full p-4 border border-gray-300 rounded-xl"
                />
                <input 
                  type="number"
                  placeholder="Quantité en stock"
                  className="w-full p-4 border border-gray-300 rounded-xl"
                />
              </div>

              <button className="w-full bg-blue-600 text-white rounded-xl p-4 font-medium">
                Créer
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};


export default GroupDetails;